import { render, staticRenderFns } from "./authtabdiolg.vue?vue&type=template&id=af5c4cba&scoped=true&"
import script from "./authtabdiolg.vue?vue&type=script&lang=js&"
export * from "./authtabdiolg.vue?vue&type=script&lang=js&"
import style0 from "./authtabdiolg.vue?vue&type=style&index=0&id=af5c4cba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5c4cba",
  null
  
)

export default component.exports